/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, Suspense } from 'react';
import ReactGA from 'react-ga4';
import { createTheme, ThemeProvider, responsiveFontSizes } from '@mui/material/styles';
import Router from './components/Router';
import { Navigation } from './components/Nav';
import { configTable } from './configTable';
import SetFavicons from '../../catalog/SetFavicons';

import SupernovaPopup from './components/SupernovaPopup';
import Header from './Header';
import './App.css';

const Footer = React.lazy(() => import('./Footer'));

export default function App(props) {
  const partnerConfig = configTable.get(props.partner);
  const {
    title, catalog, partner, logoURL, buildAChair, host, extraAttributes, headerTheme, secondaryTheme, footerTheme, headerTextColor, footerTextColor, businessInfo, origin, logo, buttonTextColor, email, phone, footerLogoStyle, bannerColor,
  } = partnerConfig;
  if (extraAttributes.icon) {
    SetFavicons(extraAttributes.icon);
  }
  const headerOptions = {
    headerTextColor,
    footerTextColor,
    title,
    logo,
    origin,
    buttonTextColor,
    partner,
    url: logoURL,
    bannerColor: bannerColor || '#007aff',
  };
  const footerOptions = {
    headerTextColor,
    footerTextColor,
    buttonTextColor,
    title,
    logo,
    businessInfo,
    origin,
    footerTheme,
    email: email || false,
    phone: phone || false,
    footerLogoStyle: {
      maxHeight: footerLogoStyle?.maxHeight || '115px',
      maxWidth: footerLogoStyle?.maxWidth || '500px',
      paddingTop: footerLogoStyle?.paddingTop || '',
    },
  };

  const noPopup = extraAttributes.popup || false;

  let theme = createTheme({
    palette: {
      primary: {
        main: headerTheme,
        contrastText: 'black',
      },
      secondary: {
        main: secondaryTheme,
        contrastText: 'black',
      },
      info: {
        main: footerTheme,
        contrastText: 'white',
      },
    },
    breakpoints: {
      values: {
        mobile: 0,
        tablet: 640,
        laptop: 1024,
        desktop: 1280,
      },
    },
  });

  theme = responsiveFontSizes(theme);

  ReactGA.initialize(extraAttributes.trackId);
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  document.title = title;
  document.partner = partner;
  document.catalog = catalog;
  document.buildAChair = buildAChair;

  extraAttributes.NoTopBar = true;
  extraAttributes.standard = origin;

  return (
    <div>
      {!noPopup
      && (
      <SupernovaPopup
        host={host}
        backgroundColor="white"
        textColor="007aff"
      />
      )}

      <ThemeProvider theme={theme}>
        <Header {...headerOptions} />
      </ThemeProvider>
      <div className="center-container">
        <div className="filter-bound-top main-nav" />
        <Suspense>
          <Router
            partner={partner}
            catalog={catalog}
            orderButtonType="rfq"
            logoURL={logoURL}
            extraAttributes={extraAttributes}
          />
        </Suspense>
      </div>
      <ThemeProvider theme={theme}>
        <Suspense fallback={<div>Loading...</div>}>
          <Footer {...footerOptions} />
        </Suspense>
      </ThemeProvider>
    </div>
  );
}
